/**
 * Created by pmerce on 09/10/2018.
 */

(function ($, Drupal, drupalSettings, doc) {

  'use strict';



    // Déclenchement géoloc sur mobile
    /*if (window.matchMedia("(max-width: 767px)").matches) {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (position) {
            });
        }
    }*/

    //Mise à jour de l'url en fonction des pré-filtres
    if (location.pathname.match(/.*recherche_offre/)) {
      var url = '';
      if ($('#field_categorie').val()) {
        url += (url ? "&" : "?");
        url += 'categorie=' + $('#field_categorie').val();
      }
      if ($('#field_enseigne').val()) {
        url += (url ? "&" : "?");
        url += 'enseigne=' + $('#field_enseigne').val();
      }
      if ($('#field_departement').val()) {
        url += (url ? "&" : "?");
        url += 'departement=' + $('#field_departement').val();
      }
      if ($('#field_contrat').val()) {
        url += (url ? "&" : "?");
        url += 'contrat=' + $('#field_contrat').val();
      }
      if ($('#field_latitude').val()) {
        url += (url ? "&" : "?");
        url += 'latitude=' + $('#field_latitude').val();
      }
      if ($('#field_longitude').val()) {
        url += (url ? "&" : "?");
        url += 'longitude=' + $('#field_longitude').val();
      }
      if ($('#field_select_address').val()) {
        url += (url ? "&" : "?");
        url += 'address=' + $('#field_select_address').val();
      }
      window.history.pushState("object or string", "", '/recherche_offre' + url);
    }

    if (location.pathname === '/recherche_offre' || location.pathname.match(/.*recherche/) || location.pathname.match(/offre-emploi/)) {
      var map;
      var markers = [];
      var user_latitude = null;
      var user_longitude = null;

      var coordinates = [47.071964, 2.900609];
      var zoom = 5;

      if ($('#raw-results').length) {
        var offers = JSON.parse($('#raw-results').html());

        if (location.pathname.match(/offre-emploi/)) {
          var coordinates = [offers[0]['field_latitude'], offers[0]['field_longitude']];
          var zoom = 11;
        }
      }

      $(document).ready(function () {
        if ($('#map').length) {
          setup_map(offers, coordinates, zoom);
        }
      });

    }

    var located = false;

    /* Evenements d'activation de la géoloc desktop et mobile */
    jQuery("#field_departement").change(function (e) {
      var id = jQuery(this).children(":selected").attr("id");
      if (id == "geolocalisation") {
        e.preventDefault();
        geolocate_user();
        jQuery('#geolocalisation-mobile').closest('div').hide();
      } else {
        $('input[name=field_address]').val('');
        $('input[name=field_select_address]').val('');
        $('input[name=field_latitude]').val('');
        $('input[name=field_longitude]').val('');
      }
    });
    jQuery('#geolocalisation-mobile').click(function (e) {
      e.preventDefault();
      geolocate_user();
      jQuery('#geolocalisation-mobile').closest('div').hide();
    });

    function setup_map(offers, coordinates, zoom) {
      init_map(coordinates, zoom);
      place_offers(offers);
    }

    function place_offers(offers_json) {
      if (offers_json.length) {
        var clusters = L.markerClusterGroup({
          iconCreateFunction: function (cluster) {
            return L.divIcon({
              html: '<b>' + cluster.getChildCount() + '</b>', className: 'cluster', iconSize: null
            });
          }
        });

        var latitude = $("#field_latitude").val();
        var longitude = $("#field_longitude").val();
        if (!!latitude && !!longitude) {
          var iconLocalisation = L.divIcon({
            iconSize: [38, 25],
            html: '<div class="tooltip-custom top"><img style="width: 25px; height: 38px;" src=\'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzNjUgNTYwIj48cGF0aCBmaWxsPSIjQUQwMDAwIiBkPSJNMTgyLjkgNTUxLjdjMCAuMS4yLjMuMi4zczE3NS4yLTI2OSAxNzUuMi0zNTcuNGMwLTEzMC4xLTg4LjgtMTg2LjctMTc1LjQtMTg2LjlDOTYuMyA3LjkgNy41IDY0LjUgNy41IDE5NC42IDcuNSAyODMgMTgyLjggNTUyIDE4Mi44IDU1MmwuMS0uM3ptLTYwLjctMzY0LjVjMC0zMy42IDI3LjItNjAuOCA2MC44LTYwLjggMzMuNiAwIDYwLjggMjcuMiA2MC44IDYwLjhTMjE2LjUgMjQ4IDE4Mi45IDI0OGMtMzMuNSAwLTYwLjctMjcuMi02MC43LTYwLjh6Ii8+PC9zdmc+\'/></div>'
          });
          var marker = L.marker([latitude, longitude], {icon: iconLocalisation});
          marker.id = 0;
          clusters.addLayer(marker);
        }

        offers_json.forEach(function (offer) {
          if (!!offer.field_latitude && !!offer.field_longitude) {
            var icon = L.divIcon({
              iconSize: null,
              html: '<div class="tooltip-custom top"><img width="100" height="30" alt="" src="' + offer.field_logo_enseigne + '"><i></i></div>'
            });

            var marker = L.marker([offer.field_latitude, offer.field_longitude], {icon: icon});
            marker.id = offer.nid;

            marker.on('click', function (e) {
              showTooltip(e.target.id);
            });

            clusters.addLayer(marker);
          }
        });
        map.addLayer(clusters);
        var bounds = clusters.getBounds();
        /* if (latitude && longitude) {
           map.setView([latitude, longitude], 8);
         } else {
           map.fitBounds(bounds, {
             padding: [100, 100]
           });
         }*/
        map.fitBounds(bounds, {
          padding: [100, 100]
        });

        if (location.pathname.match(/offre-emploi.*/)) {
          map.setZoom(11);
        }

        $('#search-results-container img').each(function () {
          $(this).addClass('offers-logo');
        });
      }
    }

    function init_map(coordinates, zoom) {
      map = L.map('map');//.setView(coordinates, zoom);


      L.tileLayer('https://c.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a>',
      }).addTo(map);

    }

    function no_results() {
      $('#find_installer .results_wrapper').removeClass('show_results');
      $('#find_installer .no_results').addClass('show');
    }

    function clearMarkers() {
      if (typeof markers !== "undefined") {
        for (var i = 0; i < markers.length; i++) map.removeLayer(markers[i]);
      }
      markers = [];
    }

    function geolocate_user(cache) {
      if (navigator.geolocation) {
        console.log('Géolocalisation en cours !');
        navigator.geolocation.getCurrentPosition(function (position) {
          $('body').addClass('loader');
          user_latitude = position.coords.latitude;
          user_longitude = position.coords.longitude;
          $.ajax({
            type: "GET",
            url: 'https://nominatim.openstreetmap.org/reverse',
            data: 'format=json&lat=' + user_latitude + '&lon=' + user_longitude,
            async: true
          }).done(function (data) {
            var modal = $("#modal-no-dpt");
            var options = $("#field_departement option");
            if (data.address && data.address.postcode) {
              var dpt = data.address.postcode.substring(0, 2);
              //Simulation Geoloc
              //var dpt = 74;
              for (var i = 0; i < options.length; i++) {
                var option = options[i];
                var optionText = option.text;
                var contains = optionText.indexOf(dpt) != -1;
                if (contains) {
                  option.selected = true;
                  located = true;
                  if (window.matchMedia("(max-width: 767px)").matches) {
                    $("#offer-search-submit").trigger("click");
                  }
                  return;
                }
              }
              // Si aucun résultat
              options[0].selected = true;
              $('.modal-no-dpt-text').html('<div class="ct-icon"><div class="icon icon-info-white"></div></div><p>Aucune annonce dans le département ' + dpt + '</p><p>Mais tu peux sélectionner manuellement un autre département</p>');
              $('body').removeClass('loader');
              modal.addClass("open");
            } else {
              options[0].selected = true;
              $('.modal-no-dpt-text').html('<div class="ct-icon"><div class="icon icon-info-white"></div></div><p>Impossible de te géolocaliser</p><p>Mais tu peux sélectionner manuellement un département</p>');
              $('body').removeClass('loader');
              modal.addClass("open");
            }
          });
        }, function (err) {
          $('body').removeClass('loader');
          /*if (window.matchMedia("(max-width: 767px)").matches) {
              jQuery('#geolocalisation-mobile').closest('div').show();
          }*/
          console.log('Géolocalisation bloquée par l\'utilisateur.');
        });
      }
    }

    function showTooltip(id) {

      var monHtml = $("html");
      var monBody = $("body");
      var popin = $('#popin-map');

      monBody.addClass('loader');

      var path = location.pathname;
      var enseigne = path.split('/');
      var latitude = $("#field_latitude").val();
      var longitude = $("#field_longitude").val();

      $.ajax({
        type: "POST", url: '/ajax/get_offer_infos', data: {
          'nid': id, 'enseigne': enseigne[2], 'latitude': latitude, 'longitude': longitude,
        }, async: true
      }).done(function (data) {
        popin.html(data.html);
        monBody.removeClass('loader');

        if (window.matchMedia("(max-width: 767px)").matches) {
          //monHtml.animate({scrollTop: popin.offset().top - 500}, 300);
        }

        if (!location.pathname.match(/.*recherche/)) {
          $('.container-map .container-info-map .info-map-header').css({'max-height': '120px', 'padding': '5px'});
          $('.container-map .container-info-map .info-map-content').css({
            'max-height': '260px', 'padding': '10px 20px'
          });
        }

        $('#search-results-container img').each(function () {
          $(this).addClass('offers-logo');
        });

        /*$('#popin-map').css('max-height', '110px');
        $('.container-map #map').css('position', '');
        $('.container-map .container-info-map').css('top', '295px');*/

        /* Ajustement du DOM pour l'affichage */

        $('.container-info-map').css('display', 'flex');
        $('.container-map .container-info-map div').first().addClass('popin-content');
        $('.container-map .container-info-map').prepend('<a class="popin-link-to-offer" href="' + $('.container-map .container-info-map .info-map-footer a').first().attr('href') + '"></a>');
        $('.container-map .container-info-map .popin-link-to-offer').prepend($('.container-map .container-info-map .popin-content'));

        $('.btn-popin-close').click(function (e) {
          e.preventDefault();
          $('#popin-map').hide();
        });

      });
    }


    if (location.pathname.match(/.*recherche/)) {
      $(".container-map").css('height', '0');
    }

    $('body').on('click', '#offer-search-submit', function (e) {
      var btn = $(this);
      recherche_offres(e, null);
    });

    $('body').on('click', '#offer-search-submit-alternance', function (e) {
      var btn = $(this);
      recherche_offres_alternance(e, null);
    });

    $('body').on('click', '.offer-paginate', function (e) {
      var btn = $(this);
      recherche_offres(e, btn.data('value'));
    });

    $('body').on('click', '.js-show-filters a', function (e) {
      $(this).toggleClass("open");
      e.preventDefault();
      $('.js-search-form').slideToggle();
    });

    //Masquage du bouton Géolocaliser si la géolocalisation est déjà activée
    if (navigator.geolocation) {
      // console.log(navigator.geolocation.getCurrentPosition());
      /*navigator.geolocation.getCurrentPosition(function(pos){
          if (pos.coords) {
              console.log(pos.coords);
          }
      });*/
      located = true;
      if (window.matchMedia("(max-width: 768px)").matches) {
        //geolocate_user();
        //$( "#offer-search-submit" ).trigger( "click" );
      }
    } else {
      if (window.matchMedia("(max-width: 767px)").matches) {
        jQuery('#geolocalisation-mobile').closest('div').show();
      }
    }

    function recherche_offres(e, page) {
      if (e) {
        e.preventDefault();
      }

      var categories = $("#field_categorie option:selected").val();
      var departement = $("#field_departement option:selected").val();
      var contrat = $("#field_contrat option:selected").val();
      var latitude = $("#field_latitude").val();
      var longitude = $("#field_longitude").val();
      var address = $("#field_select_address").val();
      var page = page;

      if ($("#field_enseigne").prop('multiple')) {
        var enseigne = [];
        $("#field_enseigne :selected").each(function () {
          enseigne.push($(this).val());
        });
      } else {
        var enseigne = $("#field_enseigne option:selected").val();
      }

      if (location.pathname.match(/.*enseigne/)) {
        var ens_name = location.pathname.split('/')[2];
        var ens_name_search = location.pathname.split('/')[3];
        if(ens_name_search === 'recherche') {
          var result_display = 'default';
        } else {
          var result_display = 'enseigne';
        }
      } else if (location.pathname === '/') {
        var result_display = 'home';
      } else {
        var result_display = 'default';
      }

      $('body').addClass('loader');

      $.ajax({
        type: "POST", url: '/ajax/recherche_offre', data: {
          'categories': categories,
          'enseigne': enseigne,
          'departement': departement,
          'contrat': contrat,
          'latitude': latitude,
          'longitude': longitude,
          'address': address,
          'page': page,
          'ens_name': ens_name,
          'result_display': result_display
        }, async: false
      }).done(function (data) {
        var offset_main = 0;
        if (result_display === 'home' || result_display === 'enseigne') {
          $('#search-results-container-home').html(data.html);
          $('#search-results-container-home').insertAfter('.search-form');
        } else {
          $('#search-results-container').html(data.html);
        }

        if (location.pathname.match(/.*recherche_offre/)) {
          //Mise à jour de l'url
          window.history.pushState("object or string", "", '/recherche_offre' + data.url);
        }
        if (location.pathname.match(/.*recherche/) || location.pathname.match(/.*recherche_offre/)) {
          $(".container-map").css('height', '0');
        }

        if (location.pathname.match(/.*enseigne/)) {
          /* Récupération du lien et transformation en lien vers le modal de confirmation */

          $('.see-more-offers').parent().addClass('hidden');
          /*$('.cross-offer').css('display', 'none');*/
          $('a.btn-modal').click(function (e) {
            linkToOffers = $(this).attr('href');
            e.preventDefault();
            $('#modal-job-alert-general').addClass('open');
            $('#modal-job-alert-general .container-btn a').last().attr('href', linkToOffers);
          });
        }
        if (!location.pathname.match(/.*recherche/)) {
          /*Affichage des filtre mobile*/
          if (window.matchMedia("(max-width: 767px)").matches) {
            $('.js-search-form').hide();
            $('.js-show-filters').show().addClass('js-show');
          }
          /* Choix de l'affichage de la liste (default) en fonction de la résolution et de la géoloc */

          $('#form-dec').addClass('embded-form-svg');
          displayExpandedList();

          /* Ajustement du DOM et du style des offres en liste pour l'affichage du lot 2 */
          $('.see-more-offers').removeClass('btn-green').addClass('btn-blue');
          $('#search-results-container').addClass('embded-search-results-container');
          $('.container-list .list-elems').addClass('resize-list-elems-default');
          $('#search-results-container .container-list').addClass('resize-container-list');
          $('.container-list .btn-container, .container-list .list-elems li').addClass('to-foreground');
          $('.container-list .list-elems li').addClass('resize-searchlist-elements');
          $('.container-list .ct-header-list').addClass('header-block');
          $('.container-list .ct-header-list .list-title').addClass('text-align-header');
          $('.container-list .ct-header-list .list-title .h2-title').addClass('resize-list-header');
          $('.container-list .see-more-offers, .container-list .cross-offer a').parent().addClass('offset-search-container-btn');
          $('.container-list .list-elems li .ct-description p').addClass('resize-list-offer-description');
          if (window.matchMedia("(max-width: 1023px)").matches) {
            $('.list-elems li').each(function () {
              $(this).addClass('mobile-display-list-elems');
              $(this).prepend('<a class="link-to-offer" href="' + $('.ct-btn .btn-blue', this).attr('href') + '"></a>');
              $('.link-to-offer', this).append($('.ct-img, .ct-name, .ct-description, .ct-btn', this));
              $('.ct-img', this).addClass('resize-elem-img');
              $('.ct-name', this).addClass('resize-elem-content');
              $('.ct-description, .ct-btn', this).hide();
              $('#search-results-container, .container-list .list-elems').css('max-height', 'unset');
            })
            var offset_main = 0;
            offset_main = $('.container-fomulaire').height();
            if (location.pathname.match(/.*enseigne/)) {
              /*$('.container-fomulaire').css('transform', 'translate(-50%, '+(offset_main-400)+'px)');
              $('.contextual-region').css('margin-top', (offset_main));*/
            } else {
              /*$('.container-groupe, .contextual-region').css('margin-top', offset_main-120);*/
            }
          }
        } else {
          $('#search-results-container').addClass('offset-search-container-search-view');
        }

        clearMarkers();
        var offers = JSON.parse($('#raw-results').html());
        var coordinates = [47.071964, 2.900609];
        var zoom = 5;
        setup_map(offers, coordinates, zoom);
        if (!location.pathname.match(/.*recherche/)) {
          $('.container-list .ct-header-list .btn-container li a').click(function () {
            if ($(this).attr('data-attr') == 'map') {
              displayExpandedMap();
              $('.container-groupe, .contextual-region').addClass('offset-main-content-map');
              $('#search-results-container').addClass('resize-search-results-container-map');
              if (location.pathname.match(/.*enseigne/)) {
                $('.container-list .see-more-offers').hide();
                $('.contextual-region').css('margin-top', '');
                $('.container-fomulaire').css('transform', '');
              }
              $('.container-map #map').css({'min-height': '480px', 'max-height': '550px'});
            } else {
              $('.container-groupe, .contextual-region').removeClass('offset-main-content-map');
              $('#search-results-container').removeClass('resize-search-results-container-map');
              displayExpandedList();
              $('#search-results-container').addClass('resize-search-results-container-list');
            }
          });
        }
        $('body').removeClass('loader');
      });
    }

    function recherche_offres_alternance(e, page) {
      if (e) {
        e.preventDefault();
      }

      var categories = $("#field_categorie option:selected").val();
      var departement = $("#field_departement option:selected").val();
      var contrat = $("#field_contrat option:selected").val();
      var page = page;

      if ($("#field_enseigne").prop('multiple')) {
        var enseigne = [];
        $("#field_enseigne :selected").each(function () {
          enseigne.push($(this).val());
        });
      } else {
        var enseigne = $("#field_enseigne option:selected").val();
      }

      if (location.pathname.match(/.*enseigne/)) {
        var ens_name = location.pathname.split('/')[2];
        var result_display = 'enseigne';
      } else if (location.pathname === '/') {
        var result_display = 'home';
      } else {
        var result_display = 'default';
      }

      $.ajax({
        type: "POST", url: '/ajax/recherche_offre', data: {
          'categories': categories,
          'enseigne': enseigne,
          'departement': departement,
          'contrat': contrat,
          'page': page,
          'ens_name': ens_name,
          'result_display': result_display
        }, async: false
      }).done(function (data) {
        if (data.url) {
          document.location.href = '/recherche_offre' + data.url + '&contrat=1169';
        } else {
          document.location.href = '/recherche_offre?contrat=1169';
        }
      });
    }

    function toArray(obj) {
      var array = [];
      for (var i = obj.length >>> 0; i--;) {
        array[i] = obj[i];
      }
      return array;
    }

    function displayExpandedList() {
      /* Affichage du lot 2 en mode liste */


      if (window.matchMedia("(max-width: 767px)").matches) {
        if (located) {
          showMap();
        }
        if (!location.pathname.match(/.*enseigne/)) {
          $('.container-list .list-elems').addClass('resize-list-elems-s');
        }
        $('.container-map').addClass('resize-container-map');
        if ($('.container-list .list-elems li').length == 0) {
          height = $('.container-list').height() + 50;
          $('#search-results-container').css('max-height', height);
        } else if ($('.container-list .list-elems li').length != 5) {
          var offset_main = 0;
          offset_main = $('.container-fomulaire').height();
          $('#path-1_1_').attr("d", "M37,0h508.5C564.6,0,580,15.4,580,34.5l0,0c0,19.1,15.4,34.5,34.5,34.5H1122 c20.4,0,37,16.6,37,37v" + (offset_main - 150) + "c0,20.4-16.6,37-37,37H37c-20.4,0-37-16.6-37-37V37C0,16.6,16.6,0,37,0z");
        }
      } else {
        $(".container-map").css('height', '0');
        if (window.matchMedia("(min-width: 1024px) and (max-width: 1179px)").matches) {
          if (location.pathname.match(/.*enseigne/)) {
            $('#path-1_1_').attr("d", "M37,0h508.5C564.6,0,580,15.4,580,34.5l0,0c0,19.1,15.4,34.5,34.5,34.5H1122 c20.4,0,37,16.6,37,37v960c0,20.4-16.6,37-37,37H37c-20.4,0-37-16.6-37-37V37C0,16.6,16.6,0,37,0z");
          } else {
            $('#path-1_1_').attr("d", "M37,0h508.5C564.6,0,580,15.4,580,34.5l0,0c0,19.1,15.4,34.5,34.5,34.5H1122 c20.4,0,37,16.6,37,37v1010c0,20.4-16.6,37-37,37H37c-20.4,0-37-16.6-37-37V37C0,16.6,16.6,0,37,0z");
          }
        } else if (window.matchMedia("(min-width: 1180px) and (max-width: 1279px)").matches) {
          $('#path-1_1_').attr("d", "M37,0h508.5C564.6,0,580,15.4,580,34.5l0,0c0,19.1,15.4,34.5,34.5,34.5H1122 c20.4,0,37,16.6,37,37v930c0,20.4-16.6,37-37,37H37c-20.4,0-37-16.6-37-37V37C0,16.6,16.6,0,37,0z");
        } else if (window.matchMedia("(min-width: 1280px) and (max-width: 1367px)").matches) {
          $('#path-1_1_').attr("d", "M37,0h508.5C564.6,0,580,15.4,580,34.5l0,0c0,19.1,15.4,34.5,34.5,34.5H1122 c20.4,0,37,16.6,37,37v810c0,20.4-16.6,37-37,37H37c-20.4,0-37-16.6-37-37V37C0,16.6,16.6,0,37,0z");
        } else if (window.matchMedia("(min-width: 1368px)").matches) {
          $('#path-1_1_').attr("d", "M37,0h508.5C564.6,0,580,15.4,580,34.5l0,0c0,19.1,15.4,34.5,34.5,34.5H1122 c20.4,0,37,16.6,37,37v810c0,20.4-16.6,37-37,37H37c-20.4,0-37-16.6-37-37V37C0,16.6,16.6,0,37,0z");
        }
      }

    }

    function displayExpandedMap() {
      /* Affichage du lot 2 en mode map */

      if (window.matchMedia("(min-width: 1024px) and (max-width: 1179px)").matches) {
        if (location.pathname.match(/.*enseigne/)) {
          $('#path-1_1_').attr("d", "M37,0h508.5C564.6,0,580,15.4,580,34.5l0,0c0,19.1,15.4,34.5,34.5,34.5H1122 c20.4,0,37,16.6,37,37v1030c0,20.4-16.6,37-37,37H37c-20.4,0-37-16.6-37-37V37C0,16.6,16.6,0,37,0z");
        } else {
          $('#path-1_1_').attr("d", "M37,0h508.5C564.6,0,580,15.4,580,34.5l0,0c0,19.1,15.4,34.5,34.5,34.5H1122 c20.4,0,37,16.6,37,37v1100c0,20.4-16.6,37-37,37H37c-20.4,0-37-16.6-37-37V37C0,16.6,16.6,0,37,0z");
        }
      } else if (window.matchMedia("(min-width: 1180px) and (max-width: 1279px)").matches) {
        $('#path-1_1_').attr("d", "M37,0h508.5C564.6,0,580,15.4,580,34.5l0,0c0,19.1,15.4,34.5,34.5,34.5H1122 c20.4,0,37,16.6,37,37v1010c0,20.4-16.6,37-37,37H37c-20.4,0-37-16.6-37-37V37C0,16.6,16.6,0,37,0z");
      } else if (window.matchMedia("(min-width: 1280px) and (max-width: 1367px)").matches) {
        $('#path-1_1_').attr("d", "M37,0h508.5C564.6,0,580,15.4,580,34.5l0,0c0,19.1,15.4,34.5,34.5,34.5H1122 c20.4,0,37,16.6,37,37v880c0,20.4-16.6,37-37,37H37c-20.4,0-37-16.6-37-37V37C0,16.6,16.6,0,37,0z");
      } else {
        $('#path-1_1_').attr("d", "M37,0h508.5C564.6,0,580,15.4,580,34.5l0,0c0,19.1,15.4,34.5,34.5,34.5H1122 c20.4,0,37,16.6,37,37v870c0,20.4-16.6,37-37,37H37c-20.4,0-37-16.6-37-37V37C0,16.6,16.6,0,37,0z");
      }
    }

    function showMap() {
      $(".container-map").slideDown();
      $(".list-elems").hide();
      var offset_main = 0;
      offset_main = $('.container-fomulaire').height();
      /*$('.container-groupe, .contextual-region').css('margin-top', (offset_main-50)+'px');*/
      $('a[data-attr="list"]').removeClass("active");
      $('a[data-attr="map"]').addClass("active");
    }

    $('body').on('click', '.switch-results', function (e) {
      e.preventDefault();
      /* Evenement changement d'affichage (map/liste) */
      if (this.attributes["data-attr"].value === "map") {
        $(".list-elems").slideUp();
        $("ul.paging-list").each(function () {
          $(this).addClass('display-hidden');
        });
        $('#search-results-container img').each(function () {
          $(this).addClass('offers-logo');
        });
        $(".container-map").show();
        if (!location.pathname.match(/.*recherche/)) {
          $('.container-map').css('height', '550px').slideDown();
        } else {
          $(".container-map").css("height", "700px").slideDown();
        }
        setTimeout(function () {
          //map.invalidateSize();
        }, 400);
      } else {
        $(".container-map").hide();
        $(".list-elems").slideDown();
        $("ul.paging-list").each(function () {
          $(this).removeClass('display-hidden');
        });
        $(".container-map").css("height", 0).slideUp();
        setTimeout(function () {
          //map.invalidateSize();
        }, 400);
      }

      $('.switch-results').removeClass("active").removeAttr("aria-current");

      $(this).addClass("active").attr("aria-current", "true");
    });
    if (jQuery('.container-map')[0]) {
      jQuery("<a href='#current-page' style='display:none;'>Passer la carte</a>").insertBefore(jQuery('.container-map'));
    }

    $('body').on('keyup focus', 'input[name=field_address]', function (e) {
      let charCode = e.which ? e.which : e.keyCode;
      //console.log(charCode);

      //if (charCode >= 96 && charCode <= 105) {
      if (charCode != 13 && !(charCode >= 37 && charCode <= 40)) {
        let searchVal = $(this).val();

        $("input[name=field_address]").on("keyup change", function (e) {
          $('input[name=field_select_address]').val('');
          $('input[name=field_latitude]').val('');
          $('input[name=field_longitude]').val('');
        });

        if (searchVal.length >= 3 /*&& !isNaN(parseInt(searchVal))*/) {
          if (!$('input[name=field_address]').data('autocomplete')) {
            $('input[name=field_address]').autocomplete({
              delay: 5,
              source: function (request, response) {
                if (request.term.length >= 3) {
                  $.ajax({
                    url: "https://api-adresse.data.gouv.fr/search/?q=" + encodeURIComponent(searchVal) + "&type=municipality&autocomplete=1&limit=6",
                    data: {q: request.term},
                    dataType: "json",
                    success: function (data) {
                      var cities = [];
                      let valPrec = '';

                      response($.map(data.features, function (item) {
                        if ($.inArray(item.properties.postcode, cities) == -1) {
                          valPrec = item.properties.city;
                          cities.push(item.properties.postcode);
                          return {
                            label: item.properties.city + " (" + item.properties.postcode.substring(0, 2) + ")",
                            postcode: item.properties.postcode,
                            value: item.properties.city,
                            lat: item.geometry.coordinates[1],
                            long: item.geometry.coordinates[0],
                          };
                        }
                      }));
                    },
                    fail: function (data) {
                      console.log(data);
                    },
                    error: function(jqXHR, textStatus, errorThrown){
                      console.log("Error handler !");
                    },
                  });
                }
              }, select: function (event, ui) {
                if (ui.item != null) {
                  $('input[name=field_select_address]').val(ui.item.label);
                  $('input[name=field_latitude]').val(ui.item.lat);
                  $('input[name=field_longitude]').val(ui.item.long);
                  $('#field_departement').prop('selectedIndex',0);
                  return false;
                }
              }, change: function (event, ui) {
                if (ui.item != null) {
                  $('input[name=field_select_address]').val(ui.item.label);
                  $('input[name=field_latitude]').val(ui.item.lat);
                  $('input[name=field_longitude]').val(ui.item.long);
                  $(e.target).val(ui.item.label);
                  $('#field_departement').prop('selectedIndex',0);
                  return false;
                }
              }, focus: function (event, ui) {
                if (ui.item != null) {
                  $('input[name=field_select_address]').val(ui.item.label);
                  $('input[name=field_latitude]').val(ui.item.lat);
                  $('input[name=field_longitude]').val(ui.item.long);
                  $('#field_departement').prop('selectedIndex',0);
                  $(e.target).val(ui.item.label);
                  return false;
                }
              }
            });
          }
        } else {
          if ($('input[name=field_select_address]').data('autocomplete')) {
            $('input[name=field_address]').autocomplete("destroy");
            $('input[name=field_address]').removeData('autocomplete');
          }
        }
      }
    });

})(jQuery, Drupal, drupalSettings, document);

